<template>
  <CToaster position="top-center">
    <CToast
      class="toast-custom-styles"
      :color="alert.color"
      :show="alert.show"
      @update:show="hide"
      :key="alert.message"
      :autohide="alert.duration"
    >
      {{ alert.message }}
    </CToast>
  </CToaster>
</template>

<script>
export default {
  name: "TheToast",
  computed: {
    alert() {
      return this.$store.state.alert;
    },
  },
  methods: {
    hide() {
      this.$store.commit("hideAlert");
    },
  },
};
</script>
<style scoped>
.toast-custom-styles {
  width: auto !important;
  margin: 0 auto;
}
</style>
